export class DialogMode {
    header: string;
    show: boolean;
    type: DialogType;
    constructor(header: string, show: boolean, type: DialogType) {
        this.header = header;
        this.show = show;
        this.type = type;
    }
  }

export type DialogType =
    | 'drafting'
    // | 'generator'
    | 'signatures'
    | 'design'
    | 'approval'
    | 'docs'
    | 'share'
    | 'exRequest'
    | 'exResponse'
    | 'respond'
    | 'engineering'
    | 'user'
    | 'plans'
    | 'invite'
    | 'assemblies'
    | 'settings'
    | 'assembly-import'
    | 'tax-error'
    | 'plan-editor'
    | 'assembly-editor';

    export class SettingDialogType {
      header: string;
      show: boolean;
      type: number;
      constructor(header: string, show: boolean, type: number) {
          this.header = header;
          this.show = show;
          this.type = type;
      }
    }
